var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9466 29.3509L24.8985 10.275C24.8985 10.275 25.1142 9.7706 24.8766 9.35909C24.6391 8.94757 24.0611 8.82461 24.0611 8.82461L1.79746 10.4169C1.79746 10.4169 0.705636 10.5579 0.460014 11.3425C0.214392 12.1272 1.12287 12.7862 1.12287 12.7862L6.34158 17.5397C6.34158 17.5397 6.9914 18.0275 7.54912 17.7055C8.10685 17.3835 15.135 14.2611 15.135 14.2611C15.135 14.2611 15.8562 14.141 16.0654 14.5035C16.2747 14.8659 15.8499 15.4993 15.8499 15.4993L8.83166 20.4682C8.83166 20.4682 8.42737 20.911 8.5651 21.7464C8.70283 22.5817 10.1556 28.7923 10.1556 28.7923C10.1556 28.7923 10.4874 29.5768 11.0395 29.6668C11.5917 29.7568 11.9466 29.3509 11.9466 29.3509Z",
    fill: "#009DBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.b4a85a94.svg";
export { ForwardRef as ReactComponent };